module.exports = __webpack_public_path__ + "static/media/JCB.a434a7b8.svg";